import {Component} from "react";

class Applet extends Component {
    constructor(props) {
        super(props);

        this.titleAttribute = null;
    };

    getEnterpriseComponent = () => {
        return this.props.enterpriseComponent;
    };

    getName = () => {
        if (this.state === null) {
            return "";
        }
        return this.state.Name;
    };

    getTitle = () => {
        if (this.getEnterpriseComponent().getSelectedRecordNumber() !== -1) {
            return this.getEnterpriseComponent().getBuffer()[this.getSelectedRecordNumber()][this.getTitleAttribute()];
        }
        return null;
    };

    getTitleAttribute = () => {
        return this.titleAttribute;
    };

    setAction(action) {
        this.setState({action: action})
    };

    unmountComponent = (obj) => {
        this.getEnterpriseComponent().removeAllListeners(obj);
    };
}

export default Applet;
